// src/components/LandingPage.jsx
import styles from "./LandingPage.module.css";
import HeroComponent from "../NewLandingComponents/HeroComponent/HeroComponent";
import logo from "../../../Images/logo.png";
import LandingPageSection2 from "../NewLandingComponents/LandingPageSection2/LandingPageSection2";
import LandingPageSection3 from "../NewLandingComponents/LandingPageSection3/LandingPageSection3";
import LandingPageSection4 from "../NewLandingComponents/LandingPageSection4/LandingPageSection4";
import LandingPage5 from "../NewLandingComponents/LandingPage5/LandingPage5";
import Testimonials from "../NewLandingComponents/Testimonials/Testimonials";
import LandingPageSection6 from "../NewLandingComponents/LandingPageSection6/LandingPageSection6";
import About from "../../About/About";
import FAQComponent from "../NewLandingComponents/FAQComponent/FAQComponent";
import VoicePopup from "../../VoicePopup/VoicePopup";
import { useState } from "react";

const LandingPage = () => {


    const [selectedAgent, setSelectedAgent] = useState(null);
  
  return (
    <div className={styles.container}>


      {/* Hero Section */}
      <HeroComponent />

      {/* Wave Divider */}
      <div className={styles.waveContainer}>
        <div className={styles.waveLine1}></div>
        <div className={styles.waveLine2}></div>
        <div className={styles.waveLine3}></div>
      </div>

      {/* Features Section */}
      <LandingPageSection2 />


      {/* AI Team Section */}
      <LandingPageSection3 selectedAgent={selectedAgent} setSelectedAgent={setSelectedAgent} />

      <LandingPageSection4 />

      <LandingPage5 />

      <Testimonials />

      <LandingPageSection6 />


      <About />


      <FAQComponent />


      <VoicePopup selectedAgent={selectedAgent}/>
    </div>
  );
};


export default LandingPage;